// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2xpxr","label":"SetPasswdForm_label__1JC2R"};